import script from "./PosInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./PosInvoice.vue?vue&type=script&setup=true&lang=js"

import "./PosInvoice.vue?vue&type=style&index=0&id=3cf1819d&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf1819d"]])

export default __exports__